import { Record, Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { obj_type, record_type, string_type, bool_type, option_type, array_type, union_type, int32_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { interpolate, toText } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { Tickets_TicketMeta_$reflection } from "../Shared/ApiDataTypes.js";
import { Tickets_TicketType__get_Id, Tickets_Segment_All, Tickets_TicketType, Tickets_TicketType_All, Tickets_TicketStatus, Tickets_TicketStatus_All, Tickets_Severity_All, Tickets_Severity, Tickets_TicketType_$reflection } from "../Shared/Shared.js";
import { FetchError, FetchError_$reflection } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { testRedirect, extraCoders } from "../Promises.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { singleton as singleton_1, cons, ofArray, empty } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { unwrap, map, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { toString } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoderCached_437914C6 } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { createObj, equals, uncurry2 } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../Context.js";
import { append } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { useEffectWithDeps } from "../fable_modules/Feliz.2.8.0/ReactInterop.js";
import { createDisposable } from "../fable_modules/Feliz.2.8.0/Internal.fs.js";
import { singleton, append as append_1, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { SnackError } from "../ViewHelpers.js";
import { Tickets_Searchbar_BBCD08A } from "./Searchbar.js";
import { Components_Filterbar_Z27381C84 } from "../Components/Filterbar.js";
import { ComponentsModule_Chip_Level, Components_Chip_51BC9844 } from "../Components/Chip.js";
import { RouterModule_encodeQueryString, RouterModule_nav } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { Components_Button_Z1043B8E } from "../Components/Button.js";
import Add from "@mui/icons-material/Add";
import { Tickets_Table_325F1C5E } from "./TicketList.js";
import { Filter } from "./TicketCenterModel.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { Skeleton, TableContainer } from "@mui/material";
import { TicketForm } from "./TicketForm.js";

export class ListTarget extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Group", "Customer", "Machine"];
    }
}

export function ListTarget_$reflection() {
    return union_type("Kundeweb.CustomerTicketList.ListTarget", [], ListTarget, () => [[["Item", int32_type]], [["groupId", int32_type], ["customerId", int32_type]], [["groupId", int32_type], ["customerId", int32_type], ["machineId", int32_type]]]);
}

export function ListTarget__RequestPath(this$, includeClosed, responsibleOnly) {
    switch (this$.tag) {
        case 1:
            return toText(interpolate("/api/tickets/customer/%d%P()?closed=%b%P()&responsible-only=%b%P()", [this$.fields[1], includeClosed, responsibleOnly]));
        case 2:
            return toText(interpolate("/api/tickets/machine/%P()?closed=%b%P()&responsible-only=%b%P()", [this$.fields[2], includeClosed, responsibleOnly]));
        default:
            return toText(interpolate("/api/tickets/group/%P()?closed=%b%P()&responsible-only=%b%P()", [this$.fields[0], includeClosed, responsibleOnly]));
    }
}

class Model extends Record {
    constructor(Target, Tickets, CreateForm, ResponsibleOnly, IncludeClosed, IncludeWarrantyAndDeviation, Filter, ErrorMsg) {
        super();
        this.Target = Target;
        this.Tickets = Tickets;
        this.CreateForm = CreateForm;
        this.ResponsibleOnly = ResponsibleOnly;
        this.IncludeClosed = IncludeClosed;
        this.IncludeWarrantyAndDeviation = IncludeWarrantyAndDeviation;
        this.Filter = Filter;
        this.ErrorMsg = ErrorMsg;
    }
}

function Model_$reflection() {
    return record_type("Kundeweb.CustomerTicketList.Model", [], Model, () => [["Target", ListTarget_$reflection()], ["Tickets", option_type(array_type(Tickets_TicketMeta_$reflection()))], ["CreateForm", option_type(Tickets_TicketType_$reflection())], ["ResponsibleOnly", bool_type], ["IncludeClosed", bool_type], ["IncludeWarrantyAndDeviation", bool_type], ["Filter", string_type], ["ErrorMsg", option_type(string_type)]]);
}

class Message extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["TicketsResponse", "ToggleCreateForm", "ToggleResponsibleOnly", "ToggleIncludeClosed", "ToggleIncludeWarrantyAndDeviations", "UpdateFilter", "SetTarget", "DismissError"];
    }
}

function Message_$reflection() {
    return union_type("Kundeweb.CustomerTicketList.Message", [], Message, () => [[["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Tickets_TicketMeta_$reflection()), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Tickets_TicketMeta_$reflection())]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", option_type(Tickets_TicketType_$reflection())]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", string_type]], [["Item", ListTarget_$reflection()]], []]);
}

function init(target) {
    return new Model(target, undefined, undefined, false, false, true, "", undefined);
}

function update(locale, model, msg) {
    switch (msg.tag) {
        case 1:
            return new Model(model.Target, model.Tickets, msg.fields[0], model.ResponsibleOnly, model.IncludeClosed, model.IncludeWarrantyAndDeviation, model.Filter, model.ErrorMsg);
        case 2:
            return new Model(model.Target, model.Tickets, model.CreateForm, msg.fields[0], model.IncludeClosed, model.IncludeWarrantyAndDeviation, model.Filter, model.ErrorMsg);
        case 3:
            return new Model(model.Target, model.Tickets, model.CreateForm, model.ResponsibleOnly, msg.fields[0], model.IncludeWarrantyAndDeviation, model.Filter, model.ErrorMsg);
        case 4:
            return new Model(model.Target, model.Tickets, model.CreateForm, model.ResponsibleOnly, model.IncludeClosed, msg.fields[0], model.Filter, model.ErrorMsg);
        case 5:
            return new Model(model.Target, model.Tickets, model.CreateForm, model.ResponsibleOnly, model.IncludeClosed, model.IncludeWarrantyAndDeviation, msg.fields[0], model.ErrorMsg);
        case 6:
            return new Model(msg.fields[0], model.Tickets, model.CreateForm, model.ResponsibleOnly, model.IncludeClosed, model.IncludeWarrantyAndDeviation, model.Filter, model.ErrorMsg);
        case 7:
            return new Model(model.Target, model.Tickets, model.CreateForm, model.ResponsibleOnly, model.IncludeClosed, model.IncludeWarrantyAndDeviation, model.Filter, undefined);
        default: {
            const res = msg.fields[0];
            if (res.tag === 1) {
                const err = res.fields[0];
                return new Model(model.Target, model.Tickets, model.CreateForm, model.ResponsibleOnly, model.IncludeClosed, model.IncludeWarrantyAndDeviation, model.Filter, (err.tag === 2) ? (((err.fields[0].status) === 401) ? locale.t("TicketList.Unauthorized") : (((err.fields[0].status) === 404) ? locale.t("NotFound") : locale.t("TicketList.FetchFailed"))) : locale.t("TicketList.FetchFailed"));
            }
            else {
                return new Model(model.Target, res.fields[0], model.CreateForm, model.ResponsibleOnly, model.IncludeClosed, model.IncludeWarrantyAndDeviation, model.Filter, model.ErrorMsg);
            }
        }
    }
}

function fetchTickets(target, includeClosed, responsibleOnly, dispatch) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let pr_1, decoder, data_1, caseStrategy_2, extra_2;
        const url = ListTarget__RequestPath(target, includeClosed, responsibleOnly);
        return ((pr_1 = ((decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Tickets_TicketMeta_$reflection()), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = extraCoders, (() => {
            let properties_2;
            try {
                const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(url, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Tickets_TicketMeta_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
            }
            catch (exn) {
                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        })()))))), pr_1.then((result_1) => Result_MapError(testRedirect, result_1)))).then((_arg_2) => {
            dispatch(new Message(0, [_arg_2]));
            return Promise.resolve();
        });
    }));
}

export function List(listInputProps) {
    const target = listInputProps.target;
    const ctx = reactApi.useContext(ctx_1);
    let patternInput;
    const arg_1 = init(target);
    patternInput = reactApi.useReducer((model, msg) => update(ctx.Locale, model, msg), arg_1);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    const patternInput_1 = reactApi.useState(true);
    const critical = patternInput_1[0];
    const patternInput_2 = (target.tag === 1) ? [target.fields[1], undefined] : ((target.tag === 0) ? [undefined, undefined] : [target.fields[1], target.fields[2]]);
    const severities = append(critical ? [new Tickets_Severity(0, [])] : [], Tickets_Severity_All());
    let statuses;
    const array_2 = Tickets_TicketStatus_All();
    statuses = array_2.filter((status) => {
        if (model_1.IncludeClosed) {
            return true;
        }
        else {
            return !equals(status, new Tickets_TicketStatus(4, []));
        }
    });
    let ticketTypes;
    const array_3 = Tickets_TicketType_All();
    ticketTypes = array_3.filter((type$0027) => {
        if (model_1.IncludeWarrantyAndDeviation) {
            return true;
        }
        else if (!equals(type$0027, new Tickets_TicketType(6, []))) {
            return !equals(type$0027, new Tickets_TicketType(5, []));
        }
        else {
            return false;
        }
    });
    useEffectWithDeps(() => {
        if (!equals(model_1.Target, target)) {
            console.debug("Customer ticket list target changed", model_1.Target, target);
            dispatch(new Message(6, [target]));
        }
        return createDisposable(() => {
            console.debug("[CustomerTicketList] unmount", target);
            dispatch(new Message(1, [undefined]));
        });
    }, [target]);
    const dependencies_1 = [target, model_1.IncludeClosed, model_1.ResponsibleOnly];
    reactApi.useEffect(() => {
        const pr = fetchTickets(target, model_1.IncludeClosed, model_1.ResponsibleOnly, dispatch);
        pr.then();
    }, dependencies_1);
    const xs_4 = toList(delay(() => append_1(singleton(createElement(SnackError, {
        errMsg: unwrap(model_1.ErrorMsg),
        dismiss: () => {
            dispatch(new Message(7, []));
        },
    })), delay(() => {
        let elems_2, elems_1, elems;
        const matchValue = model_1.Tickets;
        if (matchValue != null) {
            const tickets = matchValue;
            const matchValue_1 = model_1.CreateForm;
            if (matchValue_1 == null) {
                return append_1(singleton(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    gap: 10 + "px ",
                }], (elems_2 = [createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    alignItems: "center",
                    gap: 15 + "px ",
                    flexGrow: 1,
                }], (elems_1 = [createElement("div", {
                    style: {
                        flexBasis: 320 + "px",
                    },
                    children: createElement(Tickets_Searchbar_BBCD08A, {
                        placeholder: ctx.Locale.t("Dashboard.Tickets.Search"),
                        onUpdate: (arg_2) => {
                            dispatch(new Message(5, [arg_2]));
                        },
                    }),
                }), createElement(Components_Filterbar_Z27381C84, {
                    children: [createElement(Components_Chip_51BC9844, {
                        key: "critical-filter-chip",
                        $key: "critical-filter-chip",
                        primary: ctx.Locale.t("Ticket.Severity.Critical"),
                        enabled: critical,
                        onClick: () => {
                            patternInput_1[1](!critical);
                            switch (target.tag) {
                                case 1: {
                                    break;
                                }
                                case 0: {
                                    console.debug("Navigate");
                                    RouterModule_nav(ofArray(["groups", target.fields[0], "tickets" + RouterModule_encodeQueryString(singleton_1(["critical", "test"]))]), 1, 1);
                                    break;
                                }
                                default:
                                    undefined;
                            }
                        },
                        colorLevel: new ComponentsModule_Chip_Level(4, []),
                    }), createElement(Components_Chip_51BC9844, {
                        key: "closed-filter-chip",
                        $key: "closed-filter-chip",
                        primary: ctx.Locale.t("Ticket.Severity.Ended"),
                        enabled: model_1.IncludeClosed,
                        onClick: () => {
                            dispatch(new Message(3, [!model_1.IncludeClosed]));
                        },
                        colorLevel: new ComponentsModule_Chip_Level(1, []),
                    }), createElement(Components_Chip_51BC9844, {
                        key: "self-registered-filter-chip",
                        $key: "self-registered-filter-chip",
                        primary: ctx.Locale.t("Ticket.Severity.Registered"),
                        enabled: model_1.ResponsibleOnly,
                        onClick: () => {
                            dispatch(new Message(2, [!model_1.ResponsibleOnly]));
                        },
                    }), createElement(Components_Chip_51BC9844, {
                        key: "warranty-filter-chip",
                        $key: "warranty-filter-chip",
                        primary: ctx.Locale.t("CustomerSite.Overview.DeviationWarranties"),
                        enabled: model_1.IncludeWarrantyAndDeviation,
                        onClick: () => {
                            console.debug("Toggle warranty");
                            dispatch(new Message(4, [!model_1.IncludeWarrantyAndDeviation]));
                        },
                    })],
                })], ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), createElement(Components_Button_Z1043B8E, {
                    text: ctx.Locale.t("TicketForm.Create"),
                    onClick: (_arg_3) => {
                        dispatch(new Message(1, [new Tickets_TicketType(0, [])]));
                    },
                    startIcon: (props_4) => {
                        const props_6 = createObj(props_4);
                        return react.createElement(Add, props_6);
                    },
                })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                    let children_1;
                    return singleton((children_1 = singleton_1(createElement(Tickets_Table_325F1C5E, {
                        tickets: tickets,
                        filter: new Filter(model_1.Filter, model_1.IncludeClosed, false, undefined, undefined, undefined, Tickets_Segment_All(), severities, statuses, ticketTypes),
                        customerId: unwrap(patternInput_2[0]),
                        machineId: unwrap(patternInput_2[1]),
                    })), MuiHelpers_createElement(TableContainer, [["children", reactApi.Children.toArray(Array.from(children_1))]])));
                }));
            }
            else {
                const cf = matchValue_1;
                let patternInput_3;
                const matchValue_2 = model_1.Target;
                patternInput_3 = ((matchValue_2.tag === 1) ? [matchValue_2.fields[0], matchValue_2.fields[1], undefined] : ((matchValue_2.tag === 2) ? [matchValue_2.fields[0], matchValue_2.fields[1], matchValue_2.fields[2]] : [matchValue_2.fields[0], undefined, undefined]));
                return singleton(createElement(TicketForm, {
                    defaultType: Tickets_TicketType__get_Id(cf),
                    defaultGroup: unwrap(patternInput_3[0]),
                    defaultCustomer: unwrap(patternInput_3[1]),
                    defaultMachine: unwrap(patternInput_3[2]),
                    onClose: (didCreate) => {
                        if (didCreate) {
                            const pr_1 = fetchTickets(target, model_1.IncludeClosed, model_1.ResponsibleOnly, dispatch);
                            pr_1.then();
                        }
                        dispatch(new Message(1, [undefined]));
                    },
                }));
            }
        }
        else {
            const loadingIndicator = () => MuiHelpers_createElement(Skeleton, [["variant", "rectangular"], ["style", {
                width: 100 + "%",
                maxWidth: 600,
                height: 30,
            }]]);
            return singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                gap: 10 + "px ",
                alignItems: "center",
            }], (elems = [loadingIndicator(), loadingIndicator(), loadingIndicator()], ["children", reactApi.Children.toArray(Array.from(elems))])]))));
        }
    }))));
    return react.createElement(react.Fragment, {}, ...xs_4);
}

